export const initializeGoogleTagManager = googleTagManagerId => {
    if (!googleTagManagerId) {
        return false
    }

    if (!document.getElementById('gtm-script')) {
        const script = document.createElement('script')
        script.id = 'gtm-script'
        script.type = 'text/javascript'
        script.text = `
            (function(w, d, s, l, i) {
                w[l] = w[l] || []
                w[l].push({ 'gtm.start': new Date().getTime(), event: 'gtm.js' })
                var f = d.getElementsByTagName(s)[0],
                    j = d.createElement(s),
                    dl = l != 'dataLayer' ? '&l=' + l : ''
                j.async = true
                j.src = 'https://www.googletagmanager.com/gtm.js?id=' + i + dl
                f.parentNode.insertBefore(j, f)
            })(window, document, 'script', 'dataLayer', '${googleTagManagerId}')
        `
        document.head.appendChild(script)
    }

    if (!document.getElementById('gtm-noscript')) {
        const noScript = document.createElement('noscript')
        noScript.id = 'gtm-noscript'
        noScript.innerHTML = `<iframe src="https://www.googletagmanager.com/ns.html?id=${googleTagManagerId}" height="0" width="0" style="display:none;visibility:hidden"></iframe>`
        document.body.prepend(noScript)
    }

    return true
}

export const initializeGTagTrackMethod = tagId => {
    window.dataLayer = window.dataLayer || []
    window.gtag = function () {
        window.dataLayer.push(arguments)
    }
    window.gtag('js', new Date())
    window.gtag('config', tagId)
}
